


































































import { Component, Prop, Inject, Vue, Watch } from "vue-property-decorator";
import { deleteElement } from "@/api/delite/delite-element";
import { gallerys } from "@/config/host.config";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import { ICategory, IGallery } from "@/@types/gallsery/gallery";

@Component({ components: { ContextMenu, BSwitch, ChangeDeliteButtons } })
export default class GalleryCategorys extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: Array<ICategory | IGallery>;
  @Prop({ type: String, default: () => "category" }) type!: string;
  @Inject("folder") readonly folder!: string;
  @Inject("foldersbg") readonly foldersbg!: string;

  constxtID = "";
  $refs!: {
    menu: ContextMenu;
  };

  handler(e: PointerEvent, id: string | undefined): void {
    e.preventDefault();
    if (!id) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = id;
    });
  }

  quickChange(id: string | undefined): void {
    if (!id) return;
    const item = this.items.find((el: ICategory | IGallery) => el._id == id);
    if (!item) return;
    item.show = !item.show;
    this.$emit("quickChange", item, this.type);
  }

  async changeElement(id: string, flag: boolean): Promise<void> {
    if (flag) {
      this.$emit("changeGallery", id, this.type);
      return;
    }
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(
            this.$i18n.t(
              this.type == "gallery"
                ? "Gallery.confirm.gallery"
                : "Gallery.confirm.folder"
            )
          ),
        }
      );

      if (result === true) {
        const url =
          this.type == "gallery" ? gallerys.force : gallerys.categotys;
        deleteElement(id, url)
          .then(() => {
            this.$emit("deleteFolder", id, this.type);
            this.$notify({
              group: "global",
              text: String(this.$i18n.t("error.200")),
            });
          })
          .catch(() => {
            this.$notify({
              group: "global",
              text: String(this.$i18n.t("alerts.emptyUpdate")),
              type: "warn",
            });
          });
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  @Watch("items", { deep: true })
  test(): void {
    console.log(this.items);
  }
}
